/**
 * Query keys del dominio Inventario.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos). Los
 * **rollos** se segmentan por sede activa (`['inventario', 'rollos', { sede }]`):
 * incluir la sede en la key cachea por sede, de modo que al cambiar de sede los
 * rollos se recargan (clave distinta) en vez de mostrar los de la sede anterior.
 * La sede activa la inyecta `lib/api` como `X-Sede-Id`; aquí solo entra en la key.
 *
 * El **overview admin** es global (todas las sedes), así que su key NO lleva sede.
 */

/** Raíz de todas las queries del dominio (para invalidación amplia). */
export const INVENTARIO_ROOT_KEY = ["inventario"] as const;

/** Key de los rollos de la sede activa, segmentada por sede. */
export function rollosQueryKey(sedeId: number | null) {
  return ["inventario", "rollos", { sede: sedeId }] as const;
}

/** Key del overview admin (global, sin sede). */
export const ADMIN_OVERVIEW_KEY = ["inventario", "admin"] as const;
